import { takeLatest, call, put, takeEvery } from 'redux-saga/effects'

// Helper for api errors
import { handleApiErrors } from '../../../lib/api-errors'
import axiosApi from '../../../views/client/axiosClient'
let clientApi = axiosApi()

// Our login constants
import {
  RESEND_CONFIRMACC_REQUESTING,
  RESEND_CONFIRMACC_SUCCESS,
  RESEND_CONFIRMACC_ERROR,
  RESEND_CONFIRMACC_URL,
} from './constants'

function handleRequest (request) {
  return request
    .then(handleApiErrors)
    .then( function(response){
      return response.data;
    })
    .then(json => json)
    .catch((error) => { throw error })
}

function reSendActiveCodeApi (formData) {
  const request = clientApi.post(RESEND_CONFIRMACC_URL, 
    formData
  );
  return handleRequest(request);
}

function* reSendActiveCodeFlow (action) {
  try {
    const { formData } = action
    var result = yield call(reSendActiveCodeApi, formData)
    if (result.code != 200) {
      yield put({ type: RESEND_CONFIRMACC_ERROR, error: result.message })
    } else {
      yield put({ type: RESEND_CONFIRMACC_SUCCESS, message: result.message })
    }
    
  } catch (error) {
    // error? send it to redux
    yield put({ type: RESEND_CONFIRMACC_ERROR, error })
  }
}

// Our watcher (saga).  It will watch for many things.
function* resendActiveAccWatcher () {
  yield takeEvery(RESEND_CONFIRMACC_REQUESTING, reSendActiveCodeFlow)
}

export default resendActiveAccWatcher



// WEBPACK FOOTER //
// ./src/views/Pages/ResendConfirmAcc/sagas.js